import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { useSelector, useDispatch } from 'react-redux';
import MultiSelectDropdown from '../MultiSelectComponent/MultiSelectPrimary/selectDropDownComponent';
import {
  getTimeLineDataByYears,
  getTimeLineValue,
  getTimeLineSecondValue,
} from '../licenseAnalyticsSupport/getLicenseAnalyticsActions';
import { shortenNumber } from '../licenseAnalyticsSupport/calculationsUtils';
import './GraphComponent.css';
import { PAGE, SingleOption } from '../licenseAnalyticsSupport/typeInterfaces';
import {
  OPTIONSENUM,
  getTimeLineFirstLevelOptions,
  getTimeLineSecondLevelOptions,
} from '../licenseAnalyticsSupport/filtersOptions';
import { useTranslation } from 'react-i18next';
import { setPage, setTimeLineSecondValue, setTimeLineValue } from '../../../redux/reducers/licenceAnalytics';

type TimeLineProps = {
  page: string;
  departments: [] | undefined | any;
};

const TimelineComponent: React.FC<TimeLineProps> = ({ page, departments }) => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const timelineData:
    | {
        years: string[];
        series: {
          name: string;
          data: number[];
        }[];
        colors: string[];
      }
    | undefined = useSelector(state => getTimeLineDataByYears(state, t));
  const timeLineOptions = getTimeLineFirstLevelOptions(page);
  const timeLineValue:any = useSelector(getTimeLineValue);

  const timeLineSecondOptions = [
    ...getTimeLineSecondLevelOptions(page, timeLineValue?.id),
    ...(page === PAGE.STAFF && departments.length > 0 && (timeLineValue?.id == OPTIONSENUM.TOTALSTAFF || timeLineValue?.id == OPTIONSENUM.AVERAGESALARY) ? departments : [])
  ];
  const timeLineSecondValue:any = useSelector(getTimeLineSecondValue);

  const onTimeLineChange = (newValue: SingleOption | SingleOption[] | undefined): void => {
    dispatch(setTimeLineValue({ newValue }));
  };

  const onSecondOptionChange = (newValue: SingleOption | SingleOption[] | undefined): void => {
    dispatch(setTimeLineSecondValue({ newValue }));
  };

  let series = timelineData?.series;
  if (!series || series.length == 0) {
    series = [{ name: 'CLUB', data: [0] }];
  }
  let categories = timelineData?.years;
  if (!categories || categories.length == 0) {
    categories = ['2023'];
  }
  const options:any = {
    legend: {
      showForSingleSeries: true,
    },
    colors: timelineData?.colors,
    chart: {
      height: 100,
      type: 'area',
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      type: 'category',
      categories: categories,
    },
    yaxis: {
      labels: {
        formatter:
          timeLineValue?.id == OPTIONSENUM.ACADEMYCOSTSCLUBCOSTS ||
          timeLineSecondValue?.id == OPTIONSENUM.COACHESSAQUALIFIED
            ? (val: number): string => {
                return val?.toFixed?.() + '%';
              }
            : timeLineValue?.id == OPTIONSENUM.TOTALSTAFF || timeLineValue?.id == OPTIONSENUM.QUALIFIEDCOACHES
            ? (val: number): string => {
                return val <= 9999 ? val.toFixed() : shortenNumber(val);
              }
            : (val: number): string => shortenNumber(val),
      },
      reversed: false,
    },
  };

  useEffect(() => {
    if (timeLineValue == undefined) {
      dispatch(setPage({ page: PAGE.FINANCE }))
    }
  }, [timeLineValue])

  return (
    <div className="chart" id="chart" style={{ transform: 'scale(1.25)', transformOrigin: 'top left', width: '79%' }}>
      <div className="title">{t('TIMELINE')}</div>
      <div className="filtersWrapper">
        <MultiSelectDropdown
          options={timeLineOptions}
          value={timeLineValue}
          onChange={onTimeLineChange}
          width={'95%'}
          rootCss={{ width: '35%' }}
        />
        {timeLineSecondOptions.length > 0 ? (
          <MultiSelectDropdown
            options={timeLineSecondOptions}
            value={timeLineSecondValue}
            onChange={onSecondOptionChange}
            width={'100%'}
            rootCss={{ width: '35%' }}
            addAll
          />
        ) : (
          <></>
        )}
      </div>
      <Chart options={options} series={series} type="area" height={300} />
    </div>
  );
};

export default TimelineComponent;
